<script lang="ts" setup>
const _props = defineProps<{
  link?: LinkProps
}>()

const { frontPages } = useGlobalState()

const target = computed(() => {
  if (_props.link?.fileUrl) return '_blank'
  if (typeof _props.link?.target === 'string') return _props.link.target
  return _props.link?.target ? '_blank' : '_self'
})

const route = useRoute()
const currentOverlayRoute = computed(() => {
  // console.log(_props.link)
  return _props.link?.page?.type === 'overlayPage' &&
    route.path === frontPages.value.getStarted.slug
    ? frontPages.value.getStarted.slug + _props.link?.page?.url
    : _props.link?.page?.url || _props.link?.url
})
</script>

<template>
  <NuxtLink
    v-if="link"
    :target="target"
    :href="currentOverlayRoute || link?.url || link?.page?.url || link?.fileUrl"
    :aria-label="link?.title"
  >
    <slot />
  </NuxtLink>
</template>
